import api from '@pray/shared/utils/api';

import type { SmsConfig } from './types';

type DisableSmsProps = {
  artistId: string;
};

export async function disableSms({ artistId }: DisableSmsProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config/disable`;

  const response = await api.executePostRequest<{ data: SmsConfig }>(url);

  return response.data;
}
